import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let summary = 'Error';
      let detail = 'An unexpected error occurred.';

      if (error.status === 0) {
        summary = 'Connection Error';
        detail = 'Unable to connect to the server. Please check your network connection.';
      } else if (error.status === 404) {
        summary = 'Not Found';
        detail = error.error?.error ?? 'The requested resource was not found.';
      } else if (error.status === 422) {
        summary = 'Validation Error';
        detail = error.error?.error ?? 'One or more validation errors occurred.';
      } else if (error.status === 400) {
        summary = 'Bad Request';
        detail = typeof error.error === 'string' ? error.error : (error.error?.error ?? 'The request was invalid.');
      } else if (error.status >= 500) {
        summary = 'Server Error';
        detail = error.error?.error ?? 'An unexpected server error occurred. Please try again later.';
      } else {
        summary = `Error (${error.status})`;
        detail = error.error?.error ?? error.message ?? 'An unexpected error occurred.';
      }

      if (error.error?.traceId) {
        detail += ` (Trace: ${error.error.traceId})`;
      }

      messageService.add({
        key: 'app-error',
        severity: 'error',
        summary,
        detail,
        life: 6000
      });

      return throwError(() => error);
    })
  );
};
